import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Deletes the currently selected markers from the map.
 *
 * @yields Selects current markers and dispatches deletion actions.
 */
function* deleteMarkers() {
    try {
        const { markers, selectedMarkers } = yield select(({ map }) => ({
            selectedMarkers: map.general.selectedMarkers,
            markers: _.values(map.values.global.present.markers),
        }));

        const deletedMarkers = markers.filter((marker) =>
            selectedMarkers.includes(marker.uniqueId),
        );

        yield put(actions.map.values.global.deleteMarkers(deletedMarkers));
        yield put(actions.map.general.deselectAllMarkers());
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on deleting markers:", err);
    }
}

export default deleteMarkers;
